


























































import Vue from 'vue';
import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import CtrlJigyosho from './CtrlJigyosho.vue';

export default Vue.extend({
  name: 'ListSoko',
  components: {
    CtrlSearchCommonComponents,
    CtrlJigyosho,
  },

  props: {
    jigyoshoCd: {
      type: Number,
    },
    jigyoshoHenkoFlg: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'sokoCd',
        width: 60,
      },
      {
        text: '名称',
        sortable: true,
        value: 'sokoRyakuMei',
        width: 255,
      },
    ],
    formatColName: 'sokoCd',
    jigyoshoCdRef: 0,
    jigyoshoMei: '',
    filterGroupKey: 0,
  }),
  computed: {
    apiParams() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      let params = { mukoUmuFlg: this.mukoUmuFlg } as any;
      if (this.jigyoshoCdRef) {
        params.jigyoshoCd = this.jigyoshoCdRef;
      }
      return params;
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selectJigyoshoItem(item: any) {
      this.jigyoshoCdRef = item.jigyoshoCd;
    },
    setupJigyoshoCd() {
      if (this.jigyoshoCd) {
        this.jigyoshoCdRef = this.jigyoshoCd;
      }
    },

    resetData() {
      this.setupJigyoshoCd();
      // Increment to refresh form
      this.filterGroupKey += 1;
    },
  },
  created() {
    this.setupJigyoshoCd();
  },
});
